"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Fetcher_1 = __importDefault(require("./Fetcher"));
exports.default = Fetcher_1.default;
//# sourceMappingURL=index.js.map